module.exports = __webpack_public_path__ + "img/tail.7f135bc9.jpg";